import { DialogContent as MuiDialogContent, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
  overflowY: "visible",

  ".MuiAutocomplete-root, & > .MuiFormControl-root": {
    width: "45%",
  },
});

export const AbsenceStatus = styled(Grid)({
  width: "100%",
  justifyItems: "space-betwen",
});

export const ActionValidationContainer = styled(Grid)({
  "& button": {
    marginRight: "10px",
  },
});

export const AbsenceActionsContainer = styled(Grid)({
  width: "100%",
  justifyContent: "space-between",
  display: "flex",
  alignItems: "flex-start",

  "& button": {
    textTransform: "none",
  },
});

export const ConfirmationMessageMainContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

export const ConfirmationMessageContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  marginLeft: "10px",
});

export const ConfirmationMessageBlockContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
});

export const AbsenceStatusIndicator = styled(Grid, {
  shouldForwardProp: (props) => props !== "isRejected" && props !== "isApproved" && props !== "isCancelled",
})<{ isRejected: boolean; isApproved: boolean; isCancelled: boolean }>(
  ({ isApproved, isRejected, isCancelled, theme: { palette } }) => ({
    backgroundColor: isCancelled
      ? palette.grey[400]
      : isRejected
      ? palette.warning.light
      : isApproved
      ? palette.success.light
      : palette.primary.light,
    textDecoration: isRejected || isCancelled ? "line-through" : "",
    color: palette.primary.contrastText,
    borderRadius: "3px",
    padding: "1px",
    "&:hover": {
      cursor: "pointer",
    },
    textAlign: "center",
    width: "100%",
  })
);

export const AbsenceContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop != "wrapContent",
})<{ wrapContent: boolean }>(
  {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    position: "relative",
    height: "20px",
  },
  ({ wrapContent }) => ({
    ...(wrapContent && { flexDirection: "column", height: "unset", gap: "unset" }),
  })
);
